// @flow

import {adaptSize} from './adapt-size';
import {adaptGeneric} from './adapt-generic';
import {adaptPrice} from './adapt-price'
import {adaptColor} from './adapt-color';

const adaptFunctions = {
  size: adaptSize,
  price: adaptPrice,
  color: adaptColor,
};

const adaptFunction = (name: string): Function => {
  return adaptFunctions[name] || adaptGeneric;
};

export default adaptFunction;